<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title class="ion-text-center"><h1>Einstellungen</h1></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="mainContainer ion-text-center">
<!--
    <div style="display:flex;margin-right: auto;margin-left: 5%;">
      <h2 style="margin: auto;">Allgemein</h2>
    </div>
    <ion-list [inset]="true">
      <ion-item>
        <ion-icon aria-hidden="true" name="person-outline" slot="start"></ion-icon>
        <ion-input label="Benutzername" labelPlacement="floating" value="{{profileService.userProfile.name}}"></ion-input>
      </ion-item>

      <ion-item *ngIf="guestAcc">
        <ion-icon aria-hidden="true" name="mail-outline" slot="start"></ion-icon>
        <ion-input label="E-Mail" labelPlacement="floating" value="{{profileService.userProfile.email}}" type="email"></ion-input>
      </ion-item>

      <ion-item>
        <ion-icon aria-hidden="true" name="calendar-outline" slot="start"></ion-icon>
        <ion-input label="Geburtsdatum" labelPlacement="floating" value="12.12.2012" type="date"></ion-input>
        <ion-button id="birthDate-trigger" fill="clear" slot="end" aria-label="Info" color="primary">
          <ion-icon slot="icon-only" name="information-circle-outline" aria-hidden="true"></ion-icon>
        </ion-button>
        <ion-popover trigger="birthDate-trigger" triggerAction="click">
          <ng-template>
            <ion-content class="ion-padding">Das Geburtsdatum wird nur für die Spielerreihenfolge in den Missionen verwendet.</ion-content>
          </ng-template>
        </ion-popover>
      </ion-item>
    </ion-list>

    <br> -->

    <div style="display:flex;margin-right: auto;margin-left: 5%;">
      <h2 style="margin: auto;">Spiel</h2>
      <ion-button id="gameConfig-trigger" fill="clear" slot="end" aria-label="Info" color="tertiary">
        <ion-icon slot="icon-only" name="information-circle-outline" aria-hidden="true"></ion-icon>
      </ion-button>
      <ion-popover trigger="gameConfig-trigger" triggerAction="click">
        <ng-template>
          <ion-content class="ion-padding">Diese Einstellungen werden für jedes neue Spiel vorausgewählt.</ion-content>
        </ng-template>
      </ion-popover>
    </div>

    <div style="display:flex;margin-right: auto;margin-left: 5%;margin-top: 20px;">
      <h2 style="margin: auto;">Allgemein</h2>
    </div>
    <ion-list [inset]="true">
      <ion-item lines="none">
        <ion-icon aria-hidden="true" name="musical-notes-outline" slot="start"></ion-icon>
        <ion-toggle [checked]="!audioService.musicDisabled" (ionChange)="audioService.toggleBgMusicDisabled()">Musik</ion-toggle>
      </ion-item>
    </ion-list>

    <!-- Widerruf muss so leicht erreichbar sein wie die Zustimmung.
         Erscheint nur, wenn die Abfrage ueberhaupt aktiv ist. -->
    <ng-container *ngIf="consentRequired">
      <div style="display:flex;margin-right: auto;margin-left: 5%;margin-top: 20px;">
        <h2 style="margin: auto;">Datenschutz</h2>
      </div>

      <ion-list [inset]="true">
        <ion-item lines="none">
          <ion-icon aria-hidden="true" name="shield-checkmark-outline" slot="start"></ion-icon>
          <ion-toggle
            [checked]="marketingConsentGranted"
            (ionChange)="onMarketingConsentToggle($event)"
          >
            Messung der Herkunft
          </ion-toggle>
        </ion-item>
      </ion-list>

      <ion-text class="consent-hint">
        {{ marketingConsentGranted
            ? 'Wir dürfen speichern, über welchen Kanal du zu uns gefunden hast.'
            : 'Nur notwendige Speicherung. Deine Herkunft wird nicht über die Sitzung hinaus behalten.' }}
      </ion-text>
    </ng-container>

    <ion-text *ngIf="appVersion" style="font-size: small;">
      v{{appVersion}}
    </ion-text>


  </div>
</ion-content>

<ion-footer>
  <div class="bottomDiv">
    <!-- <ion-button expand="block" color="secondary" (click)="saveProfileData()">Speichern</ion-button> -->
    <ion-button expand="block" color="warning" (click)="deleteAccount()" class="appearOpacity delay7">Account löschen<ion-icon slot="end" name="trash-outline"></ion-icon></ion-button>
  </div>
</ion-footer>
